import { Component, OnInit } from "@angular/core";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { ConfirmationService } from "primeng/api";
import { GetUserTodoListDto } from "../../../../core/models/task-management/getUserTodoListDto";
import { LoaderService } from "../../../../core/services/loader.service";
import { TaskManagementService } from "../../../../core/services/task-management.service";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { AccordionModule } from "primeng/accordion";
import { ConfirmDialogComponent } from "../../confirm-dialog/confirm-dialog.component";
import { CommonModule } from "@angular/common";
import { DialogModule } from "primeng/dialog";
import { CardModule } from "primeng/card";
import { InputTextModule } from "primeng/inputtext";
import { SpinnerComponent } from "../../spinner/spinner.component";
import { TextareaModule } from "primeng/textarea";
import { ButtonModule } from "primeng/button";

@UntilDestroy()
@Component({
  selector: "jni-to-do-list",
  templateUrl: "./to-do-list.component.html",
  styleUrls: ["./to-do-list.component.scss"],
  providers: [ConfirmationService],
  imports: [
    AccordionModule,
    ConfirmDialogComponent,
    CommonModule,
    DialogModule,
    ReactiveFormsModule,
    CardModule,
    SpinnerComponent,
    InputTextModule,
    TextareaModule,
    ButtonModule,
  ],
})
export class ToDoListComponent implements OnInit {
  todoListForm: FormGroup;
  display = false;
  showSmallLoader = true;
  todoLists: GetUserTodoListDto[] = [];
  isEdit = false;
  dialogMessage = "Are you sure you want to proceed?";
  deleteTodoVisible = false;
  todoId: number | null = 0;

  constructor(
    private _taskManagementService: TaskManagementService,
    private _toastr: JniToastrService,
    private _formBuilder: FormBuilder,
    private _loaderService: LoaderService
  ) {
    this.todoListForm = this._formBuilder.group({
      id: [0],
      title: [
        "",
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(100),
        ],
      ],
      description: ["", [Validators.required, Validators.maxLength(250)]],
    });
  }

  ngOnInit(): void {
    this.getUsersTodoList();
  }

  showDialog() {
    this.isEdit = false;
    this.todoListForm.reset();
    this.display = true;
  }

  getUsersTodoList() {
    this.showSmallLoader = true;
    this._taskManagementService
      .getUserTodoList()
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.todoLists = res.data || [];
        },
        error: res => {
          this.showSmallLoader = false;
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  createOrUpdateTodo() {
    this._loaderService.setLoaderState(true);
    this._taskManagementService
      .addorUpdateUserTodoData(this.todoListForm.getRawValue())
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          if (res.data != null) {
            this._loaderService.setLoaderState(false);
            this._toastr.success("Success", "Todo created successfully!");
            this.getUsersTodoList();
            this.display = false;
          } else {
            this._toastr.error("Error", res.message || "Error adding client");
          }
        },
        error: res => {
          this._loaderService.setLoaderState(false);
          this._toastr.error("Error", res.message || "Error adding client");
        },
      });
  }

  deleteTodo(todoId: number) {
    this.deleteTodoVisible = true;
    this.todoId = todoId;
  }

  deleteTodoItemById(event: boolean) {
    if (event && this.todoId) {
      this._loaderService.setLoaderState(true);
      this._taskManagementService
        .deleteUserTodoItemById(this.todoId)
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res.data != null) {
              this._loaderService.setLoaderState(false);
              this._toastr.success("Success", "item deleted successfully!");
              this.getUsersTodoList();
              this.display = false;
            } else {
              this._toastr.error("Error", res.message || "Error in deleting.");
            }
          },
          error: res => {
            this._loaderService.setLoaderState(false);
            this._toastr.error("Error", res.message || "Error in deleting.");
          },
        });
    }
    this.deleteTodoVisible = false;
  }

  editTodo(item: GetUserTodoListDto) {
    this.todoListForm.patchValue(item);
    this.isEdit = true;
    this.display = true;
  }

  closeDialog() {
    this.display = false;
  }
}
